import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';

import ContentWrapper from 'components/ContentWrapper';

const Wrapper = ({ children, ...other }) => (
  <ContentWrapper>
    <Grid fluid>{children}</Grid>
  </ContentWrapper>
);

Wrapper.propTypes = { children: PropTypes.node };

export default Wrapper;
